module.exports = __webpack_public_path__ + "static/img/brand-05.4b37941.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-05.png
// module id = FNWu
// module chunks = 0